import { groupBy } from 'lodash';
import { createSelector } from 'reselect';
import { ApplicationState, getSubState } from '../types';
import { ExecuteRedemptionState } from './types';

const slice = getSubState<ApplicationState, ExecuteRedemptionState>(
  'executeRedemption'
);
export const getValidation = createSelector(
  [slice],
  ({ validation }) => validation
);

export const getRedemption = createSelector(
  [slice],
  ({ redemption }) => redemption
);

export const getAutoRedemption = createSelector(
  [slice],
  ({ autoSellLoading, autoSellFailed }) => {
    return {
      autoSellLoading,
      autoSellFailed,
    };
  }
);

export const getAutoSellSubmitResult = createSelector(
  [slice],
  ({ autoSellLoaded, autoSellFailed, autoSomeFailed, autoAllFailed }) => {
    return { autoSellLoaded, autoSellFailed, autoSomeFailed, autoAllFailed };
  }
);

export const getAutoSellTransanctions = createSelector(
  [slice],
  ({ autoSellTransactions }) => {
    return autoSellTransactions;
  }
);

/* Validations */
export const getIsValidRedemption = createSelector(
  [getValidation],
  ({ isValidRedemption }) => isValidRedemption
);

export const getValidationResultLoading = createSelector(
  [getValidation],
  ({ validationResultLoading }) => validationResultLoading
);

export const getResultsLoading = createSelector(
  [getRedemption],
  ({ redemptionResultLoading }) => redemptionResultLoading
);

/* Redemptions */
export const getSellTransactions = createSelector(
  [getRedemption],
  ({ successfulTransactions }) => successfulTransactions || []
);

export const getTransactionsLookup = createSelector(
  getSellTransactions,
  (sellTransactions) => {
    return groupBy(
      sellTransactions,
      ({ transactionRecord }) =>
        transactionRecord.sourcePositionKey.agreementKey.agreementID || 0
    );
  }
);
